<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import {
  bgFillQuaternary,
  textTertiary,
} from '@nora-monorepo/ui-shared';

const { t } = useI18n();
</script>

<template>
  <div class="flex justify-center items-center h-full">
    <div
      class="w-32 h-28 flex justify-center items-center flex-col rounded-xl p-2"
      :class="[bgFillQuaternary, textTertiary]"
    >
      <span class="mi delete md-36 mx-auto" />
      <span class="text-xs text-center mt-1">{{ t('attachments.attachmentDeleted') }}</span>
    </div>
  </div>
</template>
